/**
 * Copyright 2018 by ChartIQ, Inc.
 * All rights reserved.
 * To be implemented..
 */
export default class AppDirectory {
	constructor(client) {
		return client;
	}
}
